import React, { Dispatch, SetStateAction, useCallback } from 'react'

const useHandleDiscountRate = (update: Dispatch<SetStateAction<number>>) => {
  return useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      let value = event.target.value
      // 空文字であれば0にする
      if (/(?:)/.test(value)) {
        update(0)
      }
      // 全角数字が存在していれば全て半角数字に変換する
      value = value.replace(/[０-９]/g, (s) => {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
      })
      // 数値であれば数値型に変換して更新する
      if (/^[0-9]+$/.test(value)) {
        const num = Number(value)
        if (num > 100) return
        update(num)
      }
    },
    [update]
  )
}

export default useHandleDiscountRate
